import Vue from 'vue';

Vue.filter('toCurrency', function (value) {
    value = parseInt(value);
    if (typeof value !== "number") {
        return value;
    }

    let formatter = new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: 2
    });

    return formatter.format(value);
});

Vue.filter('toLowercase', function(value) {
    return value.toLowerCase();
});

Vue.filter('capitalize', function(value) {
    if(!value)
        return '';

    value = value.toString().toLowerCase();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('toCDNPath', function(value) {
    if(value) {
        return process.env.VUE_APP_TALLO_CDN + '/' + value;
    }
    else {
        return require('@/assets/img/blank_img.png');
    }
});